import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../../../firebase.init';
import FeedbackDetails from './FeedbackDetails';
import SingleTasks from './SingleTasks';
// import TaskDetails from './TaskDetails';
// import TaskModal from './TaskModal';
import './MyTask.css';
import TaskSubmit from './TaskSubmit';
import Resubmit from './Resubmit';
import Loading from '../../../../Share/Loading';

// interface Task {
//     _id: string
//     questionDeliverDate: string
//     questionDeliverHour: string
//     taskName: string
//     taskSerial: string
//     taskDeadline: string
//     taskMassage: string
//     submit?: string
// }

// interface Mark {
//     _id: string
//     mark: string
//     scriptfeedback: string
//     email: string
//     taskDescription: string
//     taskName: string
//     deadline: string
//     taskNo: string
//     feedbackDate: string
//     feedbackHour: string
// }

const MyTask = () => {
    const [singleTask, setSingleTask] = useState([]);
    const [taskData, setTaskData] = useState([]);
    const [toogle, setToogle] = useState(true);
    const [submit, setSubmit] = useState([])
    const [refresh, setRefresh] = useState(null)
    const [user] = useAuthState(auth)
    const [watchVideo, setWatchVideo] = useState(false)
    const [watchVideo2, setWatchVideo2] = useState(false)
    const [taskEvaluate, setTaskEvalute] = useState([]);
    const [ans, setAnswer] = useState({})
    const [marks, setMarks] = useState([]);
    const email = user?.email;
    const [loading, isLoading] = useState(false);
    



    useEffect(() => {
        fetch('https://taskla-server-hr.onrender.com/answers')
            .then(res => res.json())
            .then(data => setTaskEvalute(data))
    }
        , [])

    //find exact match data from taskEvaluate by submit data
    const fill = taskEvaluate.find((com) => {
        return com.taskNo == submit.MilstoneSerialNo
    })

    useEffect(() => {

        isLoading(true)
        fetch('https://taskla-server-hr.onrender.com/alltasks')
            .then(res => res.json())
            .then(data => {
                setSingleTask(data)
                isLoading(false)
            })
    }, [refresh])

    useEffect(() => {
        fetch(`https://taskla-server-hr.onrender.com/allMarks`)
            .then(res => res.json())
            .then(data => setMarks(data))
    }, [])

    //find exact match data from taskEvaluate by submit data
    const feed = marks.find((com) => {
        return com.taskNo == submit.MilstoneSerialNo
    })


    return (
        <div className='text-primary dark:text-slate-50'>
            <h1 className='text-2xl font-bold text-center mt-24 mb-10'>Web Development Crash Course</h1>
            {loading && <Loading />}
            <section className="grid sm:grid-cols-2 gap-6 px-10 mt-22 task-list">




                <div className=" overflow-y-auto border  pt-3 pl-2 text-base">

                    {toogle === true &&
                        <>

                            {watchVideo == "00" && <p>{taskData.moduleIntroduction}</p>

                            }

                            {watchVideo == "01" && <iframe src={taskData.Modulevideo1} frameborder="0"></iframe>

                            }
                            {watchVideo == "02" && <iframe src={taskData.Modulevideo2} frameborder="0"></iframe>

                            }
                            {watchVideo == "03" && <iframe src={taskData.Modulevideo3} frameborder="0"></iframe>

                            }
                            {watchVideo == "04" && <iframe src={taskData.Modulevideo4} frameborder="0"></iframe>

                            }
                            {watchVideo == "05" && <iframe src={taskData.Modulevideo5} frameborder="0"></iframe>

                            }
                            {watchVideo == "06" && <iframe src={taskData.Modulevideo6} frameborder="0"></iframe>

                            }

                            {watchVideo == "assignment" && <div>
                                <p>Qusetion Delivery time:{taskData.questionDeliverDate},{taskData.questionDeliverHour}</p>
                                <p>Task deadline:{taskData.taskDeadline} </p>
                                <p>Assignment Name and serial:{taskData.asignmentName}</p>
                                {taskData.assignmentInstruction}</div>

                            }

                        </>
                    }
                    <>
                        {!fill?.assignmentAnswer ? <>{toogle === false &&
                            <TaskSubmit
                                setRefresh={setRefresh}
                                submit={submit}
                                singleTask={singleTask}
                                setToogle={setToogle}
                            ></TaskSubmit>

                        }</> : <>{toogle === !true &&
                            <Resubmit
                                toogle={toogle}
                                feed={feed}
                                fill={fill}
                            ></Resubmit>
                        }</>}
                    </>


                </div>
                <div className='w-[300px] mb-3 sm:w-4/5 border h-[383px] overflow-auto' >
                    {singleTask.map((singleTask) =>
                        <SingleTasks
                            key={singleTask._id}
                            singleTask={singleTask}
                            setTaskData={setTaskData}
                            setToogle={setToogle}
                            setSubmit={setSubmit}
                            setWatchVideo={setWatchVideo}
                            setWatchVideo2={setWatchVideo2}
                        ></SingleTasks>
                    )}
                </div>
            </section>
        </div>
    );
};

export default MyTask;